<script>
	const Q = require('q');
	const page = require('page');
	const moment = require('moment');
	const model = require('model/model');
	const utilities = require('utilities');

	const { fireEvent, events } = require('utilities/analyticsUtilities');

	const studentKnowledgeInventoryUtilities = require('utilities/studentKnowledgeInventoryUtilities');
	const getSKIActiveAssignment = studentKnowledgeInventoryUtilities.getSKIActiveAssignment;
	const getSKIAssignments = studentKnowledgeInventoryUtilities.getSKIAssignments;
	const scheduleSKI = studentKnowledgeInventoryUtilities.scheduleSKI;
	const rescheduleSKI = studentKnowledgeInventoryUtilities.rescheduleSKI;
	const cancelSKI = studentKnowledgeInventoryUtilities.cancelSKI;
	const endSKI = studentKnowledgeInventoryUtilities.endSKI;

	const alertUtilities = require('utilities/alertUtilities');
	const success = alertUtilities.success;

	const { authenticateWithGoogleClassroom, isKnownGoogleClass } = require('utilities/googleClassroomUtilities');

	module.exports = {
		components: {
			'validated-form': require('components/validated-form.vue').default,
			'date-picker': require('components/date-picker.vue').default,
			'student-knowledge-inventory-about-content': require('components/student-knowledge-inventory-about-content.vue').default,
			message: require('components/message.vue').default
		},
		modelData: {
			skiAssignments: 'skiAssignments',
			classCode: 'classCode',
			roster: 'roster',
			localGCAccessToken: 'localGCAccessToken',
			skiTab: 'skiTab',
			gcClassList: 'gcClassList'
		},
		data() {
			let startDate = moment().startOf('day').toDate().getTime();
			return {
				submittedClass: null,
				loading: false,
				startDate,
				gc: true
			};
		},
		computed: {
			skiAssignment() {
				let cc = this.classCode;
				let skiAssignments = this.skiAssignments;
				let ski = null;

				if (cc && skiAssignments && skiAssignments.length) {
					skiAssignments.some(s => {
						if (!s.ed) {
							ski = s;
							return true;
						}
						return false;
					});
				}

				return ski;
			},
			skiStarted() {
				let skiAssignment = this.skiAssignment;
				return skiAssignment && skiAssignment.d < Date.now() / 1000;
			},
			currentRoster() {
				let roster = this.roster;
				let classCode = this.classCode;
				let currentRoster = {};

				if (roster && roster[classCode]) {
					currentRoster = roster[classCode];
				}

				return currentRoster;
			},
			className() {
				let currentRoster = this.currentRoster;
				let name = null;

				if (currentRoster && currentRoster.name) {
					name = currentRoster.name;
				}

				return name;
			},
			gcTokenMismatch() {
				const gcid = this.currentRoster.gcid;

				return gcid && this.gcClassList && !isKnownGoogleClass(gcid);
			},
			needsGoogleAuth() {
				const gcid = this.currentRoster.gcid;
				const gc = this.skiAssignment ? !!this.skiAssignment.gcid : this.gc;
				/* No GCA check needed - inaccessible in GCA */

				return gcid && gc && (!this.localGCAccessToken || this.gcTokenMismatch);
			}
		},
		methods: {
			previewSKI() {
				let cc = this.classCode;
				model.set('skiWorkspaceBack', {
					href: window.location.href,
					text: 'Assignments'
				});
				page('/student-knowledge-inventory-workspace');
				model.set('classCode', cc);
				fireEvent(events.SKI_PREVIEW, {
					cc,
					loc: 'assignments'
				});
			},
			openSKIScheduler() {
				let skiAssignment = this.skiAssignment;
				this.submittedClass = null;

				if (skiAssignment) {
					this.startDate = skiAssignment.d * 1000;
				}

				utilities.openModal('#modal-student-knowledge-inventory-assign');
			},
			onScheduleSKISubmit() {
				let cc = this.classCode;
				let d = this.startDate;
				let currentRoster = this.currentRoster;
				let skiAssignment = this.skiAssignment;
				let rmsid = skiAssignment && skiAssignment.rmsid;
				let prms = Q();
				let isGoogleClass = currentRoster && currentRoster.gcid;
				let isGoogleSki = skiAssignment ? !!skiAssignment.gcid : this.gc;
				let token = isGoogleClass && isGoogleSki ? this.localGCAccessToken : undefined;

				this.loading = true;

				if (skiAssignment) {
					prms = rescheduleSKI(cc, d, rmsid, token);
				} else {
					prms = scheduleSKI(cc, d, token);
				}
				prms
					.then(resp => {
						rmsid = rmsid || resp.rmsid;
						fireEvent(events.SKI_ASSIGN, {
							rmsid,
							cc,
							d
						});
						success('Your Reading Mindset Snapshot has been scheduled!');
					})
					.finally(() => {
						this.submittedClass = this.currentRoster;
						this.loading = false;
					});
			},
			onMaybeCancelSKI() {
				utilities.openModal('#modal-student-knowledge-inventory-cancel');
			},
			onCancelSKI() {
				let cc = this.classCode;
				let skiAssignment = this.skiAssignment;
				let rmsid = skiAssignment && skiAssignment.rmsid;
				let isGoogleSki = skiAssignment && !!skiAssignment.gcid;
				let token = isGoogleSki ? this.localGCAccessToken : undefined;

				this.loading = true;
				cancelSKI(cc, rmsid, token)
					.then(() => success('Your Reading Mindset Snapshot has been canceled.'))
					.finally(() => {
						utilities.closeModals();
						this.loading = false;
					});
			},
			onMaybeEndSKI() {
				utilities.openModal('#modal-student-knowledge-inventory-end');
			},
			onEndSKI() {
				let cc = this.classCode;
				let skiAssignment = this.skiAssignment;
				let rmsid = skiAssignment && skiAssignment.rmsid;
				let isGoogleSki = skiAssignment && !!skiAssignment.gcid;
				let token = isGoogleSki ? this.localGCAccessToken : undefined;

				this.loading = true;
				endSKI(cc, rmsid, token)
					.then(() => success('Your Reading Mindset Snapshot has ended.'))
					.finally(() => {
						utilities.closeModals();
						this.loading = false;
					});
			},
			onViewResultsClick() {
				this.skiTab = 'results';
			},
			authenticateWithGoogle() {
				authenticateWithGoogleClassroom();
			}
		},
		watch: {
			classCode(cc) {
				if (cc) {
					this.loading = true;
					Q.all([getSKIActiveAssignment(cc), getSKIAssignments(cc)]).finally(() => (this.loading = false));
				}
			}
		},
		mounted() {
			let cc = this.classCode;
			fireEvent(events.SKI_ABOUT_VIEW, {
				cc,
				loc: 'assignments'
			});
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.ski-about {
		h2.ski-status {
			border-bottom: 1px solid $c-grey;
			padding: 1rem 0;
		}
	}
</style>
<template>
	<div class="ski-about">
		<h2
			v-if="!loading && skiAssignment"
			class="ski-status">
			Your Reading Mindset Snapshot {{ skiStarted ? 'began on' : 'is scheduled for' }} {{ skiAssignment.d | date }}.
		</h2>
		<h3>Get to know your students as readers and watch them grow!</h3>
		<template v-if="!skiAssignment && !skiAssignments">
			<!-- Never assigned RMS -->
			<student-knowledge-inventory-about-content></student-knowledge-inventory-about-content>
		</template>
		<template v-if="skiAssignment">
			<template v-if="skiAssignments.length === 1">
				<!-- First RMS underway -->
				<p v-if="skiStarted">Your students are currently taking their first Reading Mindset Snapshot. Their results will help you learn about:</p>
				<p v-if="!skiStarted">Your students are scheduled to take their first Reading Mindset Snapshot. Their results will help you learn about:</p>
				<ul>
					<li>Their feelings about reading</li>
					<li>Topics they are interested in</li>
				</ul>
			</template>
			<template v-if="skiAssignments.length > 1">
				<!-- Second+ RMS Underway -->
				<p>Your students are taking their next Reading Mindset Snapshot. Their results will help you learn:</p>
				<ul>
					<li>How their feelings about reading have changed this year</li>
					<li>Topics they are still interested in and new topics they have discovered they enjoy</li>
				</ul>
			</template>
		</template>
		<template v-if="!skiAssignment && skiAssignments && skiAssignments.length">
			<!-- RMS complete -->
			<p v-if="skiAssignments.length === 1">
				Your students have completed their first Reading Mindset Snapshot. Now you can use the results to help your students:
			</p>
			<p v-if="skiAssignments.length > 1">
				Your students have completed their most recent Reading Mindset Snapshot. Now you can compare these results to their prior Reading Mindset
				Snapshot.
			</p>
			<ul>
				<li>Read and comprehend challenging texts by connecting what you assign to their interests</li>
				<li>Choose texts for independent reading that motivate them</li>
				<li>Enjoy reading more by understanding their own feelings about reading</li>
			</ul>
			<p>Consider assigning the Reading Mindset Snapshot 2-3 more times throughout the year to see how your students grow and change as readers.</p>
		</template>
		<div
			class="text-centered margin-top-medium"
			v-if="!loading && classCode">
			<button
				v-if="!skiAssignment"
				class="button schedule-button"
				@click="openSKIScheduler">
				Schedule
			</button>
			<button
				v-if="skiAssignment && skiStarted"
				class="button end-button"
				@click="onMaybeEndSKI">
				End
			</button>
			<button
				v-if="skiAssignment"
				class="button cancel-button"
				@click="onMaybeCancelSKI">
				Cancel
			</button>
			<button
				v-if="skiAssignment && !skiStarted"
				class="button reschedule-button"
				@click="openSKIScheduler">
				Reschedule
			</button>
			<button
				class="button preview-button"
				@click="previewSKI">
				Preview or Print
			</button>
			<button
				v-if="skiAssignments && skiAssignments.length > 0"
				@click="onViewResultsClick"
				class="button results-button">
				View Results
			</button>
		</div>
		<modal
			id="modal-student-knowledge-inventory-assign"
			:ok="false"
			:loading="loading">
			<template slot="header-container">
				<h2>Schedule{{ submittedClass ? 'd' : '' }}</h2>
				<p>Reading Mindset Snapshot</p>
			</template>
			<div slot="content">
				<validated-form
					v-if="!submittedClass && roster && className"
					:on-submit="onScheduleSKISubmit"
					class="survey-assign-modal-body">
					<div>
						<p>Please note:</p>
						<ul v-if="!currentRoster.gcid">
							<li>The Reading Mindset Snapshot will be the first assignment your students see until they complete it.</li>
						</ul>
						<ul v-if="currentRoster.gcid">
							<li>The Reading Mindset Snapshot will not post to your Google Classroom stream.</li>
							<li>
								Students will need to sign into the ReadWorks website to access it, where it will be the first assignment in their To Do list until they
								complete it.
							</li>
						</ul>
					</div>
					<div class="ski-date start-date date margin-bottom-medium">
						<div class="label">Start Date</div>
						<div class="form-row-input">
							<date-picker
								:date.sync="startDate"
								required>
							</date-picker>
						</div>
					</div>
					<div
						v-if="currentRoster.gcid"
						class="ski-gc-publish margin-bottom-medium">
						<label class="google-classroom-checkbox input-wrapper checkbox-wrapper">
							<input
								class="input-checkbox"
								type="checkbox"
								v-model="gc" />
							Publish to Google Classroom
						</label>
					</div>
					<div
						v-if="needsGoogleAuth"
						class="text-centered margin-bottom-small">
						<message
							v-if="gcTokenMismatch"
							type="error">
							Please authenticate the Google account used to manage this Classroom
						</message>
						<button
							class="button"
							type="button"
							@click="authenticateWithGoogle">
							Authenticate with Google
						</button>
					</div>
					<div class="text-centered">
						<button
							class="button"
							:class="{
								'-in-progress': submitting
							}"
							:disabled="submitting || needsGoogleAuth"
							type="submit">
							Schedule
						</button>
					</div>
				</validated-form>
				<div
					v-if="submittedClass && className && skiAssignment"
					class="student-knowledge-inventory-pilot-confirm">
					<p><strong>Scheduled for:</strong> {{ className }}</p>
					<p><strong>Date:</strong> {{ skiAssignment.d | date }}</p>
					<p v-if="skiAssignment.gcid">Published to Google Classroom</p>
					<p class="text-centered">
						<a
							data-modal-close
							class="button -small -outline">
							Close
						</a>
					</p>
				</div>
			</div>
		</modal>
		<modal
			id="modal-student-knowledge-inventory-cancel"
			:loading="loading">
			<template slot="header-container">
				<h2>Cancel Reading Mindset Snapshot</h2>
			</template>
			<div slot="content">
				<p class="text-centered">
					<template v-if="skiStarted"
						>This will delete the active assessment and you will not be able to see the results of any students who may have completed the survey.</template
					>
					Are you sure you want to cancel the Reading Mindset Snapshot?
				</p>
				<div
					v-if="needsGoogleAuth"
					class="margin-top-bottom-medium text-centered">
					<message
						v-if="gcTokenMismatch"
						type="error">
						Please authenticate the Google account used to manage this Classroom
					</message>
					<button
						class="button"
						type="button"
						@click="authenticateWithGoogle">
						Authenticate with Google
					</button>
				</div>
				<div class="margin-top-bottom-medium text-centered">
					<button
						class="button"
						type="submit"
						:disabled="needsGoogleAuth"
						@click="onCancelSKI">
						Yes
					</button>
					<button
						data-modal-close
						class="button -outline">
						Not Yet
					</button>
				</div>
			</div>
		</modal>
		<modal
			id="modal-student-knowledge-inventory-end"
			:loading="loading">
			<template slot="header-container">
				<h2>End Reading Mindset Snapshot</h2>
			</template>
			<div slot="content">
				<p class="text-centered">
					This will close the current assessment and students who have not yet completed the survey will no longer be able to do so. Are you sure you want
					to end the Reading Mindset Snapshot?
				</p>
				<p class="text-centered">
					<button
						v-if="needsGoogleAuth"
						class="button"
						type="button"
						@click="authenticateWithGoogle">
						Authenticate with Google
					</button>
				</p>
				<p class="text-centered">
					<button
						class="button"
						type="submit"
						:disabled="needsGoogleAuth"
						@click="onEndSKI">
						Yes
					</button>
					<button
						data-modal-close
						class="button -outline">
						Not Yet
					</button>
				</p>
			</div>
		</modal>
	</div>
</template>
